<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsLeveeDeFonds'
});
</script>
<template>
  <ka-container
    code="prog-11-levee-de-fonds"
    :data="page.$info.prog11LeveeDeFonds">
    <!-- Container de page formation -->
    <ka-container code="container-de-page-formation">
      <PFormationEntete
        instance-class="pf-page-formation-entete--p64"
        h-1="Préparation à la levée de fonds"
        texte="La formation est réalisée par un<strong> expert en levée de fonds</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container
        code="container-experts"
        :options="{ hidden: null }">
        <ka-text code="titre">
          <span v-html="t('prog11LeveeDeFonds.containerDePageFormation.containerExperts.titre.value', `Nos experts en levée de fonds`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog11LeveeDeFonds.containerDePageFormation.containerExperts.texte.value', `Matchers vous met en relation avec un expert expérimenté pour vous coacher dans chaque étape de votre levée de fonds. De l'établissement de votre pitch à la gestion de vos relations avec les investisseurs en passant par les négociations, son accompagnement vous permet d’être formé et préparé à tous les scénarios possibles. `)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p64"
            :tags="page.$constants.blocPreviewProfilExpertTags" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p64"
            :tags="page.$constants.element1Tags" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p64"
            :tags="page.$constants.element2Tags" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p64"
            :tags="page.$constants.element3Tags" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog11LeveeDeFonds.containerDePageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog11LeveeDeFonds.containerDePageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p64"
                  titre="I.   Introduction à la levée de fonds"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-1">
                <DropDownFormation
                  instance-class="element-4--p64"
                  titre="II.   Définir une stratégie de financement de l'entreprise ou du projet"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-5--p64"
                  titre="lll.   Maîtriser les outils, les éléments juridiques et financiers de la levée de fonds"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-6--p64"
                  titre="IV.   Être capable de pitcher votre projet, convaincre et négocier avec des investisseurs"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-4">
                <DropDownFormation
                  instance-class="element-7--p64"
                  titre="V.   Trouver les financements complémentaires"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p64" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p64"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p64" />
      <PFormationMatching
        instance-class="p-formation-matching--p64"
        description-company="<strong>Vievent</strong> | Entreprise proposant des animations virtuelles et interactives lors d'événements.<br> <br> <br><strong>Besoin : </strong>Bénéficier de financements pour lancer la startup."
        expert-text="<strong>Julien </strong>| CEO | &#64;WeLikeStartup.<br> <br> <br><strong>Expertise : </strong>Près de 8 ans d'expérience dans les domaines du financement, de l'entrepreneuriat/intrapreneuriat, de l'innovation et des startups."
        budget-available="4 300€"
        support-duration="d’accompagnement par semaine durant 8 semaines."
        photo-expert="https://ucarecdn.com/a36891b6-52eb-42c1-b5fd-afaec5d821e7/"
        image="https://ucarecdn.com/03f88c10-84b0-4c42-85f8-c1e33eaa46b3/" />
      <PFormationCriteresQualiopi instance-class="pf-criteres-qualiopi--p64" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsLeveeDeFonds } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p64')
const appData = appDataStore()
const page = formationsLeveeDeFonds()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
